//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getPermissionRuleList, queryPermissionRule } from '@/api/api';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import PermissionDataRuleModal from "./modules/PermissionDataRuleModal";
var columns = [{
  title: '规则名称',
  dataIndex: 'ruleName',
  align: "center",
  key: 'ruleName'
}, {
  title: '规则字段',
  align: "center",
  dataIndex: 'ruleColumn',
  key: 'ruleColumn'
}, {
  title: '规则值',
  align: "center",
  dataIndex: 'ruleValue',
  key: 'ruleValue'
}, {
  title: '操作',
  dataIndex: 'action',
  scopedSlots: {
    customRender: 'action'
  },
  align: 'center'
}];
export default {
  name: 'PermissionDataRuleList',
  mixins: [JeecgListMixin],
  components: {
    PermissionDataRuleModal: PermissionDataRuleModal
  },
  data: function data() {
    return {
      queryParam: {},
      drawerWidth: 650,
      columns: columns,
      permId: '',
      visible: false,
      form: this.$form.createForm(this),
      loading: false,
      url: {
        list: "/sys/permission/getPermRuleListByPermId",
        delete: "/sys/permission/deletePermissionRule"
      }
    };
  },
  created: function created() {
    this.resetScreenSize();
  },
  methods: {
    loadData: function loadData() {
      var that = this;
      this.dataSource = [];
      var params = this.getQueryParams(); //查询条件

      getPermissionRuleList(params).then(function (res) {
        if (res.success) {
          that.dataSource = res.result;
        }
      });
    },
    edit: function edit(record) {
      if (record.id) {
        this.visible = true;
        this.permId = record.id;
      }

      this.queryParam = {};
      this.queryParam.permissionId = record.id;
      this.visible = true;
      this.loadData();
      this.resetScreenSize();
    },
    addPermissionRule: function addPermissionRule() {
      this.$refs.modalForm.add(this.permId);
      this.$refs.modalForm.title = '新增';
    },
    searchQuery: function searchQuery() {
      var _this = this;

      var params = this.getQueryParams();
      params.permissionId = this.permId;
      queryPermissionRule(params).then(function (res) {
        if (res.success) {
          _this.dataSource = res.result;
        }
      });
    },
    searchReset: function searchReset() {
      this.queryParam = {};
      this.queryParam.permissionId = this.permId;
      this.loadData(1);
    },
    onClose: function onClose() {
      this.visible = false;
    },
    // 根据屏幕变化,设置抽屉尺寸
    resetScreenSize: function resetScreenSize() {
      var screenWidth = document.body.clientWidth;

      if (screenWidth < 500) {
        this.drawerWidth = screenWidth;
      } else {
        this.drawerWidth = 650;
      }
    },
    getRowClassname: function getRowClassname(record) {
      if (record.status != 1) {
        return "data-rule-invalid";
      }
    }
  }
};